<script>
    export let query;

    import Main from '../components/Main.svelte'
    import SectionText from '../components/Sections/SectionText.svelte'
    import SectionTable from '../components/Sections/SectionTable.svelte'
    import PageLoader from '../components/PageLoader.svelte'
    import { fetchData, getURL } from '../utils/functions';
</script>

<svelte:head>
    <title>Factsheet - Global Shipping Watch</title>
</svelte:head>

{#await fetchData(`factsheets?context_name=${query}`)}
    <PageLoader />
{:then data} 
<Main>
    <div class="section section-factsheet-info section-cent fp-auto-height-responsive bg-primary" data-section="info">
        <section class="content clearfix fit">
        <!-- Begin of Content -->
        <div class="content-factsheet-info c-columns fit">
            <div class="row wrapper">
            <div class="columns small-12 medium-12 large-12">
                <div class="col-wrapper anim">
                <!-- title -->
                <header class="title-desc">
                    <span class="anim-wrapper">
                        <span class="factsheet-header">
                            <h2 class="page-title">{data[0].country.name}</h2>
                            <img class="factsheet-flag" src={getURL(data[0].country.flag.url)} alt="">
                        </span>
                    </span>
                </header>

                <ul class="contact-list c-features row small-up-12 medium-up-12 large-up-12">
                    <!-- item -->
                    <li class="column anim">
                    <div class="item-desc">
                        <span class="anim-wrapper">
                            <h3 class="title">{data[0].type_of_trade}, {data[0].year}</h3>
                        </span>
                        <div class="desc">
                            <span class="anim-wrapper">
                                <p>Matching rate: <strong>{data[0].matching_rate}</strong>%</p>
                            </span>
                        </div>
                        <div class="desc row">
                                {#each JSON.parse(data[0].info_text).blocks as block}
                                    <span class="anim-wrapper">
                                        <p>{@html block.data.text}</p>
                                    </span>
                                {/each}
                        </div>
                    </div>
                    </li>
                </ul>

                </div>
            </div>
            </div>
        </div>
        <!-- End of Content -->
        </section>
    </div>
    <!-- End of contact section -->
    {#each data[0].table_collections as collection}
        <SectionTable
            content={collection}
            context={{country: data[0].country, year : data[0].year, type_of_trade: data[0].type_of_trade}}
        />
    {/each}
</Main>
{/await}